import React, { memo } from 'react';
import { useSelector } from 'react-redux';
import { boundsLayersSelector } from '@selectors/layers-selector';
import Layers from './layers';
import VectorTileLayer from './vector-tile-layer';

const LayerList = () => {
  // Return only layers within bounds (and the visible ones):
  const layers = useSelector(boundsLayersSelector);
  return Object.keys(layers).map(name => {
    const layer = layers[name];
    if (layer.use_vector_tiles) {
      return <VectorTileLayer key={`vector-tile-layer-${name}`} name={name} />;
    }
    return <Layers key={`layer-${name}`} {...layer} />;
  });
};

export default memo(LayerList);
